<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<button class="btn btn-outline-primary" [ngClass]="{ active: isActive, primary: type === 'primary' }">
  {{ label }}
</button>
